/* BASIIC theme — predictive-search.js */
(function () {
  'use strict';
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      if (!this.input || !this.results) return;
      this.input.addEventListener('input', window.basiic.debounce(() => this.onInput(), 300));
      this.input.setAttribute('autocomplete', 'off');
    }
    async onInput() {
      const q = this.input.value.trim();
      if (q.length < 2) { this.results.innerHTML = ''; this.results.hidden = true; return; }
      const url = `${window.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search`;
      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('#shopify-section-predictive-search');
        this.results.innerHTML = inner ? inner.innerHTML : '';
        this.results.hidden = false;
      } catch (e) { this.results.innerHTML = ''; this.results.hidden = true; }
    }
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
})();
